/**
 * Configuraciones de las 3 landings SEO.
 * Cada landing tiene 1000+ palabras propias, tono NiTanAdicto y evita
 * canibalización semántica entre sí:
 *
 *   /libros-de-adicciones   → keyword head: "libros de adicciones"
 *   /libro-de-sobriedad     → keyword head: "libro de sobriedad"
 *   /cuentos-para-adictos   → keyword head: "cuentos para adictos"
 */

const HERO_BOOK =
    "https://customer-assets.emergentagent.com/job_autodestruccion-sa/artifacts/96mtdjwo_image.png";
const HERO_AUTHOR =
    "https://customer-assets.emergentagent.com/job_autodestruccion-sa/artifacts/e20qonn4_image.png";

export const LIBROS_ADICCIONES_CONFIG = {
    slug: "libros-de-adicciones",
    crumbLabel: "Libros de adicciones",
    heroImage: HERO_BOOK,
    seoTitle:
        "Libros de adicciones en español gratis · El Principio del Mapa Inverso",
    seoDescription:
        "Libros de adicciones en español, escritos por Nelson González Rodríguez. Descarga gratis 'El Principio del Mapa Inverso' (PDF + EPUB) y lee la serie 'Cuentos para adictos'. Sin costo, sin letra chica.",
    seoKeywords:
        "libros de adicciones, libros de adicciones gratis, libros sobre adicciones en español, libros de adicción, libros de recuperación adicciones, libro adicción Chile, libro sobriedad, Nelson González Rodríguez, El Principio del Mapa Inverso, Cuentos para adictos, libro digital adicción gratis, libro pdf adicción, autor chileno adicción, recuperación drogas libro, alcoholismo libro, manual sobriedad",
    eyebrow: "Biblioteca · lecturas 100% gratis",
    h1Prefix: "Libros de adicciones en español —",
    h1Highlight: "sin moralina,",
    h1Suffix: "gratis y escritos desde adentro.",
    kicker:
        "Toda la obra de Nelson González Rodríguez sobre adicción, recaídas, familia y sobriedad. Cero paywalls. Cero curso caro. Cero receta mágica. Solo textos de alguien que estuvo en la primera línea durante más de 20 años y hoy sostiene la sobriedad un día a la vez.",
    about: [
        "Libros de adicciones",
        "Recuperación de adicciones",
        "Sobriedad consciente",
        "Autodestrucción",
    ],
    obrasHeadline: "La biblioteca completa — dos obras, cero costo.",
    sections: [
        {
            h2: "Qué encuentras acá",
            body: [
                "Esta página junta todos los libros de adicciones que escribí y publiqué en español. Todos son gratis. Todos se leen o se descargan sin registro pesado. Y todos vienen del mismo lugar: mi propia recuperación después de más de veinte años en consumo activo y ocho meses de internación.",
                "No son manuales clínicos. No son autoayuda motivacional. No prometen que en 21 días vas a cambiar tu vida. Son textos que documentan cómo se rompe una vida, cómo se rearma, y qué pasa mientras tanto. Los publico gratis porque cuando yo los necesitaba no existían gratis, en mi idioma, sin moralina.",
            ],
        },
        {
            h2: "El Principio del Mapa Inverso — libro largo, 16 capítulos",
            body: [
                "Es el libro grande. 141 páginas divididas en cuatro partes: la caída, los centros, los patrones y la reconstrucción. No es un manual paso a paso: es más parecido a un mapa dibujado a mano después de conocer el territorio completo.",
                "Se descarga en PDF + EPUB. Llega por email en menos de un minuto. No hay tarjeta, no hay upsell, no hay letra chica.",
            ],
            list: [
                "Parte I — La caída: nombrar el vacío, la primera droga (alcohol), Autodestrucción S.A., comisarías y desayunos de cocaína.",
                "Parte II — Los centros: primer centro de rehabilitación, el centro caro que no me salvó, ambulatorio y drogado en la primera sesión.",
                "Parte III — Los patrones: la trampa de sentirme bien, la recaída no empieza con la sustancia, pasta base, la familia también se enferma.",
                "Parte IV — La reconstrucción: rendirse para vivir, no es voluntad — es sistema, sobriedad con sentido, el mapa inverso.",
            ],
        },
        {
            h2: "Cuentos para adictos — serie corta, 4 cuentos",
            body: [
                "Cuatro cuentos breves. Cada uno agarra una frase que se dice mil veces en los grupos —'los dos lobos', 'quemar las naves', 'evita personas, lugares y cosas'— y en vez de repetirla la continúa. Ahí aparece lo que la frase original nunca resolvió.",
                "Tres son para la persona con la adicción. El cuarto, 'Papá, ¿qué es un adicto?', es para leer en familia con niños y adolescentes cuando la conversación no encuentra por dónde empezar.",
            ],
            list: [
                "La casa de los lobos — sobre el que no alimentaste.",
                "El último barco — sobre volver a decidir después de 'quemar las naves'.",
                "La ciudad de las puertas — sobre el craving que aparece sin anunciarse.",
                "Papá, ¿qué es un adicto? — para leer con niños de 8 a 13 años.",
            ],
        },
        {
            h2: "Para quién funcionan estos libros",
            body: [
                "Funcionan bien para tres perfiles concretos. Y no funcionan para todos: eso también es información útil.",
                "Si buscás promesas rápidas, milagros o un plan de 12 pasos empaquetado, estos libros te van a incomodar. Si buscás textos honestos, escritos por alguien que estuvo ahí y que dice qué le sirvió y qué no, probá.",
            ],
            list: [
                "Personas en consumo activo que ya se cansaron de decir 'la próxima semana empiezo'.",
                "Personas con tiempo en recuperación que necesitan textos que no las traten como niños ni las evangelicen.",
                "Familias que aman a alguien que se está perdiendo y quieren entender lo que ven, sin manual de 'cómo salvarlo'.",
            ],
        },
        {
            h2: "Cómo se leen o descargan",
            body: [
                "El libro largo se descarga desde /descargar. Solo pide nombre, email y país. Al enviar el formulario llega el link seguro al correo. Compatible con cualquier dispositivo, sin DRM agresivo. Se puede compartir con familiares o personas en tratamiento siempre que se acredite al autor.",
                "Los cuatro cuentos se leen directamente en SinAdicciones.org, sin registro. Se pueden guardar como PDF desde el navegador si querés tenerlos offline.",
            ],
        },
        {
            h2: "Sobre el autor — quién los escribió y por qué",
            body: [
                "Nelson González Rodríguez. Autor chileno. Fundador de SinAdicciones.org y de PlanSobrio.com. Estuve ocho meses internado y llevo años sosteniendo la sobriedad un día a la vez. Escribo estos libros porque cuando los necesitaba no existían gratis, en español, sin moralina.",
                "No soy terapeuta de cabecera ni vocero cotidiano. Mi trabajo es dejar herramientas que se puedan usar cuando yo no estoy. Estos libros son una de esas herramientas. Los cuentos son otra. SinAdicciones.org (tests de autoevaluación, calculadora de costos, orientación confidencial y comunidad web) es la tercera.",
            ],
        },
    ],
    faqs: [
        {
            q: "¿Cuáles son los mejores libros de adicciones en español gratis?",
            a: "Los dos libros de adicciones en español gratis mejor calificados hoy son 'El Principio del Mapa Inverso' de Nelson González Rodríguez (16 capítulos, 141 páginas, PDF + EPUB) y la serie 'Cuentos para adictos' del mismo autor (4 cuentos breves, lectura online). Ambos se acceden sin costo y sin registro pesado.",
        },
        {
            q: "¿Los libros reemplazan un tratamiento profesional?",
            a: "No. Ningún libro de adicciones reemplaza evaluación médica, terapia psicológica, un centro de rehabilitación ni una línea de crisis. Los libros son un complemento honesto: sirven para entender lo que te pasa, encontrar palabras, y decidir informado con qué profesional trabajar. En Chile podés llamar al 1412 (SENDA) para orientación telefónica gratuita.",
        },
        {
            q: "¿Puedo compartir estos libros con un familiar en consumo?",
            a: "Sí. Todos los libros de adicciones publicados por Nelson González Rodríguez tienen licencia de lectura y difusión libre, siempre acreditando al autor. Podés reenviar el link o el PDF a familiares, amigos o personas en tratamiento. Recomendación: no fuerces la lectura — dejá el archivo disponible y esperá a que quien lo necesite lo abra.",
        },
        {
            q: "¿En qué se diferencian estos libros de otros libros sobre adicción?",
            a: "En tres cosas: (1) escritos desde adentro, no desde una teoría — el autor tiene más de 20 años de consumo activo y años de sobriedad sostenida; (2) sin moralina ni receta única — no hay 'el método' ni 12 pasos empaquetados; (3) 100% gratis en español y accesibles desde cualquier país hispanohablante.",
        },
    ],
};

export const LIBRO_SOBRIEDAD_CONFIG = {
    slug: "libro-de-sobriedad",
    crumbLabel: "Libro de sobriedad",
    heroImage: HERO_BOOK,
    seoTitle:
        "Libro de sobriedad sin moralina · El Principio del Mapa Inverso",
    seoDescription:
        "Libro de sobriedad en español, gratis. Nelson González Rodríguez escribe sobre sobriedad consciente, recaídas y reconstrucción sin promesas ni recetas mágicas. Descarga PDF + EPUB.",
    seoKeywords:
        "libro de sobriedad, libro sobriedad gratis, libro sobriedad consciente, libro sobriedad en español, libro sober curious, libro para dejar de beber, cómo dejar el alcohol libro, Nelson González Rodríguez, El Principio del Mapa Inverso, sobriedad sin moralina, sobriedad Chile, libro recuperación alcoholismo, libro después de rehabilitación, libro para sostener sobriedad, libro sobre recaídas, libro salud mental Chile",
    eyebrow: "Libro de sobriedad · 141 pág · 100% gratis",
    h1Prefix: "Un libro de sobriedad que",
    h1Highlight: "no promete",
    h1Suffix: "milagros — solo un mapa.",
    kicker:
        "Sobriedad consciente escrita por alguien que sabe que no basta con dejar de tomar. 'El Principio del Mapa Inverso' es el libro que me habría gustado tener el día que salí de ocho meses de internación y descubrí que la parte difícil recién empezaba.",
    about: [
        "Sobriedad consciente",
        "Recuperación",
        "Alcoholismo",
        "Recaídas",
        "Salud mental",
    ],
    obrasHeadline: "Los libros que sostienen mi sobriedad hoy.",
    sections: [
        {
            h2: "Qué significa 'sobriedad con sentido' — y qué no",
            body: [
                "'Sobriedad con sentido' no es un slogan. Es lo único que me sostiene después de años sin consumir. Estar sobrio no es dejar de tomar y ya. Eso es la parte que se ve. Lo que no se ve, y lo que este libro trata de nombrar, es qué haces con las emociones, la vida social, la rabia, el aburrimiento, el orgullo y el silencio cuando el trago ya no aparece a llenar los huecos.",
                "Este libro de sobriedad no promete que vas a ser feliz. Promete un mapa. Eso es distinto y es mucho.",
            ],
        },
        {
            h2: "Para quién está pensado este libro de sobriedad",
            body: [
                "Está pensado para tres perfiles. Fuera de esos tres, es probable que otro libro te sirva más.",
            ],
            list: [
                "Personas recién salidas de un tratamiento — internación, ambulatorio o programa de día — que descubrieron que la parte social y emocional de la sobriedad no venía en el paquete.",
                "Personas con años sostenidos que necesitan un texto honesto para volver a pensar por qué siguen sobrias cuando el entorno les ofrece razones para no serlo.",
                "Personas 'sober-curious' que todavía no están en un consumo problemático pero saben que su relación con el alcohol necesita revisión antes de que se vuelva un problema.",
            ],
        },
        {
            h2: "Los tres capítulos más citados del libro",
            body: [
                "El libro completo son 16 capítulos, pero tres son los que más me marcan mensajes cuando alguien lo termina. Los dejo con contexto para que decidas si es tu momento de abrirlo.",
            ],
            list: [
                "Capítulo 9 · 'La trampa de sentirme bien' — sobre por qué el momento más peligroso de la sobriedad no es el peor: es cuando todo empieza a mejorar y aparece la idea 'quizás ahora sí podría controlarlo'.",
                "Capítulo 10 · 'La recaída no empieza con la sustancia' — la anatomía de una recaída paso a paso. Nunca empieza con el trago. Empieza con una emoción no dicha, un límite mal puesto, una promesa vacía.",
                "Capítulo 15 · 'Sobriedad con sentido' — qué construís para reemplazar lo que dejaste. Sin propósito, la sobriedad se hace una privación. Con propósito, se hace un lugar donde estás por elección, no por castigo.",
            ],
        },
        {
            h2: "Cómo se sostiene una sobriedad — lo que aprendí en ocho meses adentro y muchos años afuera",
            body: [
                "Ocho meses de internación me enseñaron a no consumir. La vida después me enseñó a sostenerlo. Son dos aprendizajes distintos. Este libro cubre el segundo.",
                "No es un programa. Es una serie de observaciones sobre qué funciona a largo plazo y qué se rompe. Algunas te van a incomodar si venís de tradiciones que ordenan mucho lo que uno puede o no decir en recuperación. Yo pongo el énfasis en tres cosas.",
            ],
            list: [
                "Herramientas concretas antes que discursos — un plan de 24 horas ordenado vale más que un mantra motivacional.",
                "Personas que te llaman por tu nombre, no por tu diagnóstico — el vínculo con alguien que te sostiene en el momento gris importa más que el grupo perfecto.",
                "Un propósito claro, adaptado a tu vida — no todos sirven para ser padrinos ni para hacer podcasts de recuperación; sirven otras cosas.",
            ],
        },
        {
            h2: "Cómo descargar el libro de sobriedad — es gratis",
            body: [
                "Se descarga en /descargar. Formulario corto: nombre, email, país. Sin tarjeta. Sin trial. Sin freemium. Llega el link al correo en menos de un minuto y se puede abrir en cualquier dispositivo.",
                "Si además querés lecturas más cortas para el bolsillo, en /cuentos-para-adictos hay cuatro cuentos breves del mismo autor, gratis y sin registro.",
            ],
        },
    ],
    faqs: [
        {
            q: "¿Este libro de sobriedad reemplaza terapia o un centro?",
            a: "No. Y lo dice en cada capítulo. Es un compañero de ruta, no un sustituto. Si estás en consumo activo o en riesgo, buscá ayuda profesional. En Chile podés llamar al 1412 (SENDA) para orientación gratuita. En Latinoamérica, entrá a SinAdicciones.org para encontrar tratamiento verificado por país.",
        },
        {
            q: "¿Sirve si nunca fui a rehabilitación y solo quiero reducir mi consumo?",
            a: "Sí. Es útil especialmente para personas 'sober-curious' que todavía no están en consumo problemático pero saben que su relación con el alcohol necesita revisión. El capítulo 2 ('Alcohol, mi primera droga') funciona bien como espejo temprano.",
        },
        {
            q: "¿Es un libro religioso o basado en 12 pasos?",
            a: "No. No es religioso, no repite el vocabulario de 12 pasos y no ordena creencias. Respeta esas tradiciones cuando ayudan pero también cuestiona lo que no funciona. Es un libro de sobriedad consciente, no un manual de programa.",
        },
        {
            q: "¿En qué formatos está disponible?",
            a: "PDF y EPUB. Compatible con celular, tablet, computador y lectores tipo Kindle. Sin DRM agresivo, para uso personal. Podés compartirlo con familiares o personas en tratamiento acreditando al autor.",
        },
    ],
};

export const CUENTOS_ADICTOS_CONFIG = {
    slug: "cuentos-para-adictos",
    crumbLabel: "Cuentos para adictos",
    heroImage: HERO_AUTHOR,
    seoTitle:
        "Cuentos para adictos · 4 cuentos gratis de Nelson González Rodríguez",
    seoDescription:
        "Cuentos para adictos: 4 cuentos breves de Nelson González Rodríguez sobre adicción, craving, recaídas y familia. Lectura gratuita en español. La casa de los lobos, El último barco, La ciudad de las puertas, Papá ¿qué es un adicto?",
    seoKeywords:
        "cuentos para adictos, cuentos sobre adicciones, cuentos cortos adicción, cuentos recuperación, cuentos sobriedad, La casa de los lobos cuento, El último barco Nelson González, La ciudad de las puertas cuento, Papá qué es un adicto, Nelson González Rodríguez, literatura adicción español, cuentos alcoholismo, cuento sobre craving, cuento sobre recaída, cuento para leer en familia adicción, literatura sobriedad Chile",
    eyebrow: "Serie literaria · 4 cuentos · lectura gratuita",
    h1Prefix: "Cuentos para adictos —",
    h1Highlight: "las frases",
    h1Suffix: "que empiezan justo donde otras terminan.",
    kicker:
        "Cuatro cuentos breves. Cada uno agarra una frase que se repite mil veces en los grupos de recuperación — 'los dos lobos', 'quemar las naves', 'evita personas/lugares/cosas' — y en vez de repetirla la continúa. Publicados gratis en SinAdicciones.org.",
    about: [
        "Cuentos para adictos",
        "Literatura sobre adicciones",
        "Recuperación",
        "Craving",
        "Familia y adicción",
    ],
    obrasHeadline: "Los cuentos + el libro largo. Todo del mismo autor.",
    sections: [
        {
            h2: "Cómo nacieron estos cuentos",
            body: [
                "En terapia y en los grupos se dicen frases que empiezan con la intención de ordenar y terminan por gastarse de tanto repetirlas. Las escuché durante ocho meses adentro y las sigo escuchando afuera. Todas tienen algo cierto. Pero todas se apagan en el mismo punto: cuando llegás a la parte que la frase original no responde.",
                "Estos cuatro cuentos hacen justo eso: agarran la frase, la respetan, y siguen escribiendo desde donde ella se calla.",
            ],
        },
        {
            h2: "Los cuatro cuentos, en orden de lectura sugerido",
            body: [
                "No hay un orden obligatorio: cada cuento se lee solo. Pero si vas a leer los cuatro y no sabés por dónde empezar, este orden funciona bien.",
            ],
            list: [
                "1. La casa de los lobos — la frase 'gana el lobo que alimentas' te dice qué hacer con uno. ¿Y qué hago con el otro? Un cuento sobre convivir con la parte de vos que no se va.",
                "2. La ciudad de las puertas — 'evita personas, lugares y cosas' es un buen consejo. ¿Y cuando el lugar es la ciudad donde vivís? Un cuento sobre craving y las decisiones que empiezan mucho antes de cruzar la puerta.",
                "3. El último barco — 'quemar las naves' suena definitivo. Pero en la orilla siempre queda madera. Un cuento sobre la decisión que hay que tomar de nuevo.",
                "4. Papá, ¿qué es un adicto? — un niño de trece años le pregunta a su papá. Un cuento para leer con niños y adolescentes en familia.",
            ],
        },
        {
            h2: "Para quién funciona cada cuento",
            body: [
                "No todos los cuentos sirven al mismo lector. Esta es la orientación honesta, sin promesa de que todos van a movilizarte igual.",
            ],
            list: [
                "'La casa de los lobos' — para cualquiera en cualquier etapa de recuperación. Útil también para quien nunca ha tenido una adicción pero convive con una parte de sí mismo que no sabe manejar.",
                "'La ciudad de las puertas' — especialmente útil si tenés craving y no entendés de dónde salió, y también para familiares que quieren entender qué es el craving por dentro.",
                "'El último barco' — para personas con tiempo en recuperación que descubrieron que la decisión grande no se toma una sola vez.",
                "'Papá, ¿qué es un adicto?' — para padres, madres, tíos, profes, cuidadores. Se puede leer junto a niños de 8 a 13 años.",
            ],
        },
        {
            h2: "Cómo se leen — sin registro, sin costo",
            body: [
                "Los cuatro cuentos están publicados en SinAdicciones.org/cuentos-para-adictos. Se leen directo en el navegador, sin login, sin correo. Cada uno es corto: entre 5 y 10 minutos de lectura.",
                "Podés guardarlos como PDF desde el navegador si querés tenerlos offline. La licencia permite compartirlos libremente acreditando al autor.",
            ],
        },
        {
            h2: "El libro largo del mismo autor",
            body: [
                "Si los cuentos te resonaron y querés algo más largo, existe 'El Principio del Mapa Inverso' — mi libro digital de 16 capítulos sobre adicción, recaídas, centros de rehabilitación y sobriedad con sentido. Se descarga gratis en PDF + EPUB desde /descargar. También sin tarjeta, sin trial, sin letra chica.",
            ],
        },
    ],
    faqs: [
        {
            q: "¿Los cuentos para adictos son ficción o testimonio?",
            a: "Son ficción con base testimonial. Los personajes y las situaciones están inventados, pero las emociones y los mecanismos vienen de mi propia recuperación y de conversaciones con personas en tratamiento. Se leen como cuentos, no como memorias.",
        },
        {
            q: "¿Puedo leerlos con mis hijos o alumnos?",
            a: "El cuento 'Papá, ¿qué es un adicto?' está escrito específicamente para leer en familia con niños y adolescentes de 8 a 13 años. Los otros tres son adecuados para lectores mayores de 15 años porque tocan temas de consumo, craving y recaída con más crudeza.",
        },
        {
            q: "¿Están disponibles en audiobook o solo en texto?",
            a: "Por ahora solo en texto, publicados online en SinAdicciones.org. Estamos evaluando una edición en audio pero aún no hay fecha. Podés guardar cada cuento como PDF desde el navegador si querés leerlos offline.",
        },
        {
            q: "¿Puedo usarlos en un taller, grupo terapéutico o proyecto educativo?",
            a: "Sí. La licencia permite usarlos en talleres, grupos, escuelas y proyectos comunitarios siempre que acredites al autor (Nelson González Rodríguez) y menciones la fuente (SinAdicciones.org/cuentos-para-adictos). Si querés coordinar una lectura conjunta con el autor, escribí a través del formulario de contacto.",
        },
    ],
};
